import { createFileRoute } from '@tanstack/react-router'
import SistemaPortaisPage from '@/pages/dashboard/sistema-portais-page'
import { ProtectedRoute, RequireModule } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'
import { MODULES } from '@/constants/modules'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/sistema/portais',
)({
  component: function SistemaPortaisRoute() {
    const { dashboardId } = Route.useParams()
    return (
      <RequireModule module={MODULES.PORTAIS} dashboardId={dashboardId}>
        <ProtectedRoute capability={CAPABILITIES.MANAGE_DASHBOARD_CONFIG}>
          <SistemaPortaisPage />
        </ProtectedRoute>
      </RequireModule>
    )
  },
})
